import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../constants';

const Sponsor = styled.div`
    padding: 1.5rem;
    display: flex;
    align-items: center;
    h4 {
        margin-right: 1rem;
    }
    @media (max-width: ${breakpoints.mobile}) {
        display: block;
        text-align: center;
        h4 {
            margin-right: 0;
            margin-bottom: 1rem;
        }
    }
`;

export default ({ title, url, img, maxHeight = 0 }) => (
    <Sponsor>
        {title && <h4>{title}</h4>}
        <a href={url}>
            <img src={img} style={{ maxHeight: maxHeight || 'auto' }} />
        </a>
    </Sponsor>
);



// WEBPACK FOOTER //
// ./src/components/Sponsor.js